import client from '@libs/HttpClient';
class PermissionService {
    static getPermissionForRoles(param,search) {
        return client.get(`/permission/permission-list/${param}?search=${search}`);
    }
    static assignPermission(request){
        return client.patch('/permission/assign-permission',request);
    }
}
export { PermissionService };
